import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { ReactComponent as DropdownIcon } from 'src/Images/icons/common/dropdown.svg';
import { ReactComponent as Calendar } from 'src/Images/icons/common/calendar.svg';
import getColorCode from 'src/utils/GetThemeColor';
import 'src/style/createVehicleTracking.css';

function AdditionalDetails({ formData, handleOnChange }) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;

  const choices = [
    { id: 1, name: 'Average' },
    { id: 2, name: 'Good' },
    { id: 3, name: 'Excellent' },
  ];

  return (
    <div className="create-form-container form-input-container">
      <Row className="create-form-row">
        <Col
          className={`theme-scrollable-container-${themeColor} scrollable-container`}
        >
          <Row className="py-2">
            <span className="text-lg text-semi-bold">Driver Details</span>
          </Row>
          <Row>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Name</span>
                </div>
                <input
                  name="driverName"
                  data-testid="driver-name-input"
                  className="margin-top-5 form-input-section"
                  type="text"
                  value={formData.driverName || ''}
                  onChange={handleOnChange}
                />
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Mobile Number</span>
                </div>
                <input
                  name="driverMobileNumber"
                  className="margin-top-5 form-input-section"
                  type="text"
                  value={formData.driverMobileNumber || ''}
                  onChange={handleOnChange}
                />
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">License Number</span>
                </div>
                <input
                  name="driverLicenseNumber"
                  className="margin-top-5 form-input-section"
                  type="text"
                  value={formData.driverLicenseNumber || ''}
                  onChange={handleOnChange}
                />
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">License Validity</span>
                </div>
                <div className="input-wrapper">
                  <input
                    name="licenseValidity"
                    className="margin-top-5 form-input-section input-icon-date"
                    type="date"
                    value={formData.licenseValidity || ''}
                    onChange={handleOnChange}
                  />
                  <span className="form-input-section-icon">
                    <Calendar
                      className="icon-size-sm"
                      color={getColorCode(themeColor)}
                    />
                  </span>
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">License Validity</span>
                </div>
                <div className="input-wrapper">
                  <input
                    name="licenseValidity"
                    className="margin-top-5 form-input-section input-icon-date"
                    type="date"
                    value={formData.licenseValidity || ''}
                    onChange={handleOnChange}
                  />
                  <span className="form-input-section-icon">
                    <Calendar
                      className="icon-size-sm"
                      color={getColorCode(themeColor)}
                    />
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="py-3 border-top mt-2">
            <span className="text-lg text-semi-bold">Document Details</span>
          </Row>
          <Row>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Eway Bill Number</span>
                </div>
                <input
                  name="eWayBill"
                  className="margin-top-5 form-input-section"
                  size="small"
                  type="text"
                  value={formData.eWayBill || ''}
                  onChange={handleOnChange}
                />
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">COA</span>
                </div>
                <input
                  name="coa"
                  className="margin-top-5 form-input-section"
                  size="small"
                  type="text"
                  value={formData.coa || ''}
                  onChange={handleOnChange}
                />
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Container Number</span>
                </div>
                <input
                  name="containerNumber"
                  className="margin-top-5 form-input-section"
                  size="small"
                  type="text"
                  value={formData.containerNumber || ''}
                  onChange={handleOnChange}
                />
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Original Invoice</span>
                </div>
                <div className="input-wrapper">
                  <input
                    name="originalInvoice"
                    className="margin-top-5 form-input-section"
                    type="text"
                    value={formData.originalInvoice || ''}
                    onChange={handleOnChange}
                  />
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Weight Slip</span>
                </div>
                <div className="input-wrapper">
                  <input
                    name="weightSlip"
                    className="margin-top-5 form-input-section"
                    type="text"
                    value={formData.weightSlip || ''}
                    onChange={handleOnChange}
                  />
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Remarks</span>
                </div>
                <div className="input-wrapper">
                  <input
                    name="remarks"
                    className="margin-top-5 form-input-section"
                    type="text"
                    value={formData.remarks || ''}
                    onChange={handleOnChange}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="py-3 border-top mt-2">
            <span className="text-lg text-semi-bold">Vehicle Details</span>
          </Row>
          <Row>
            <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Tank Condition</span>
                </div>
                <div className="input-wrapper">
                  <select
                    name="tankCondition"
                    data-testid="tank-condition-select"
                    onChange={handleOnChange}
                    className="margin-top-5 form-input-section input-icon-remove"
                    value={formData.tankCondition || ''}
                  >
                    <option value="">Select a value</option>
                    {choices.map((choice) => (
                      <option key={choice.id} value={choice.id}>
                        {choice.name}
                      </option>
                    ))}
                  </select>
                  <span className="form-input-section-icon">
                    <DropdownIcon
                      className="icon-size-sm"
                      color={getColorCode(themeColor)}
                    />
                  </span>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Information Panel</span>
                </div>
                <div className="input-wrapper">
                  <select
                    name="informationPanel"
                    onChange={handleOnChange}
                    className="margin-top-5 form-input-section input-icon-remove"
                    value={formData.informationPanel || ''}
                  >
                    <option value="">Select a value</option>
                    {choices.map((choice) => (
                      <option key={choice.id} value={choice.id}>
                        {choice.name}
                      </option>
                    ))}
                  </select>
                  <span className="form-input-section-icon">
                    <DropdownIcon
                      className="icon-size-sm"
                      color={getColorCode(themeColor)}
                    />
                  </span>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Lid Condition</span>
                </div>
                <div className="input-wrapper">
                  <select
                    name="lidCondition"
                    onChange={handleOnChange}
                    className="margin-top-5 form-input-section input-icon-remove"
                    value={formData.lidCondition || ''}
                  >
                    <option value="">Select a value</option>
                    {choices.map((choice) => (
                      <option key={choice.id} value={choice.id}>
                        {choice.name}
                      </option>
                    ))}
                  </select>
                  <span className="form-input-section-icon">
                    <DropdownIcon
                      className="icon-size-sm"
                      color={getColorCode(themeColor)}
                    />
                  </span>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Tyre Condition</span>
                </div>
                <div className="input-wrapper">
                  <select
                    name="tyreCondition"
                    onChange={handleOnChange}
                    className="margin-top-5 form-input-section input-icon-remove"
                    value={formData.tyreCondition || ''}
                  >
                    <option value="">Select a value</option>
                    {choices.map((choice) => (
                      <option key={choice.id} value={choice.id}>
                        {choice.name}
                      </option>
                    ))}
                  </select>
                  <span className="form-input-section-icon">
                    <DropdownIcon
                      className="icon-size-sm"
                      color={getColorCode(themeColor)}
                    />
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="padding-top-10">
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="tremCard"
                  type="checkbox"
                  onChange={handleOnChange}
                  checked={formData.tremCard || false}
                />
                <span className="text-sm text-bold">TREM Card</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="reflectors"
                  type="checkbox"
                  onChange={handleOnChange}
                  checked={formData.reflectors || false}
                />
                <span className="text-sm text-bold">Reflectors</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="safetyHelmet"
                  type="checkbox"
                  onChange={handleOnChange}
                  checked={formData.safetyHelmet || false}
                />
                <span className="text-sm text-bold">Safety Helmet</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="safetyShoes"
                  type="checkbox"
                  onChange={handleOnChange}
                  checked={formData.safetyShoes || false}
                />
                <span className="text-sm text-bold">Safety Shoes</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="safetyHandgloves"
                  type="checkbox"
                  onChange={handleOnChange}
                  checked={formData.safetyHandgloves || false}
                />
                <span className="text-sm text-bold">Safety Handgloves</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="safetyGoggles"
                  type="checkbox"
                  onChange={handleOnChange}
                  checked={formData.safetyGoggles || false}
                />
                <span className="text-sm text-bold">Safety Goggles</span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default AdditionalDetails;
